export default __webpack_public_path__ + "static/media/arrow-sidebar-button.4f9d8d5f.svg";